import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 24px 24px 48px 24px;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      padding: 16px 16px 32px 16px;
    }
  `}
`;

export const Subtitle = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.sm2};
    font-weight: ${theme.v2.font.weights.medium};
    color: ${theme.v2.colors.neutral.lowDark};
  `}
`;

export const Description = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    color: ${theme.v2.colors.neutral.lowDark};

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }    
  `}
`;

export const CurrentSO = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 8px;
`;

export const CurrentSOTitle = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.sm2};
    font-weight: ${theme.v2.font.weights.medium};
    color: ${theme.v2.colors.neutral.lowDark};
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
  `}
`;

export const CurrentSOTitleIcon = styled.img`
  width: 40px;
  height: 40px;
  display: block;
`;

export const CurrentSODescription = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    color: ${theme.v2.colors.neutral.lowDark};
    margin-top: 8px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `}
`;

export const AddonsContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 24px;
    border-radius: 16px;
    background-color: ${theme.v2.colors.neutral.highLight};
    width: 100%;
    gap: 24px;
    margin-top: 8px;
  `}    
`;

export const AddonsTitle = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.sm2};
    font-weight: ${theme.v2.font.weights.medium};
    color: ${theme.v2.colors.neutral.lowDark};
  `}
`;

export const AddonsSubtitle = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.medium};
    color: ${theme.v2.colors.neutral.lowMedium};
  `}
`;

export const AddonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 8px;
`;

export const AddonsItem = styled.span`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    font-size: ${theme.v2.font.sizes.sm2};
    font-weight: ${theme.v2.font.weights.medium};
    color: ${theme.v2.colors.neutral.lowDark}; 
    
    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xs};
    }
  `}
`;

export const AddonsItemIcon = styled.img`
  width: 40px;
  height: 40px;
  display: block;
`;

export const TabsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`;

export const TabsHeader = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 16px;
    margin: 8px 0;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      flex-direction: column;
    }
  `}
`;

export const TabsHeaderItem = styled.div`
  ${({ theme, $active }) => css`
    padding: 6px 16px;
    border-radius: 30px;
    background-color: ${theme.v2.colors.white.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    color: ${theme.v2.colors.neutral.lowPure};
    border: 1px solid ${theme.v2.colors.neutral.highMedium};
    cursor: pointer;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;    
    gap: 8px;
    user-select: none;
    text-align: center;

    ${$active && css`
      background-color: ${theme.v2.colors.brand.primaryLowLight};
      border-color: ${theme.v2.colors.brand.primaryLowLight};
      color: ${theme.v2.colors.brand.primaryMedium};
    `}

    @media (max-width: ${theme.v2.breakpoints.md}) {
      width: 100%;
      padding: 7px 16px;
    }
  `}
`;

export const TabsContent = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-wrap: wrap;
    gap: 24px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      flex-direction: column;
      gap: 16px;
    }  
  `}
`;

export const TabContentItem = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    padding: 16px;
    border-radius: 10px;
    border: 1px solid ${theme.v2.colors.neutral.highMedium};
    cursor: pointer;
    flex: 1;
    width: 100%;
    min-width: 265px;
    max-width: 265px;
    user-select: none;

    &:hover {
      border-color: ${theme.v2.colors.brand.primaryMedium};
      box-shadow: 0 0 20px 0 ${theme.v2.colors.brand.primaryMedium}33;
    }

    &:active {
      background-color: ${theme.v2.colors.brand.primaryLowLight};
      border-color: transparent;
      box-shadow: none;
    }    

    @media (max-width: ${theme.v2.breakpoints.md}) {
      width: 100%;
      min-width: 100%;
      max-width: 100%;
    }      
  `}
`;

export const TabContentItemIcon = styled.img`
  width: 40px;
  height: 40px;
  display: block;
`;

export const TabContentItemTitle = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
    color: ${theme.v2.colors.neutral.lowDark};

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }    
  `}
`;

export const WrapperLoaderPage = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.neutral.highPure};
    z-index: 100;
    gap: 6px;
    width: 100%;
    height: 60vh;
    max-height: 700px;
    border-radius: 16px;    
  `}
`;
